import React, { Fragment } from 'react';
import {
    Button,
    Form,
    Input,
    TextArea,
    Segment,
    Grid,
    Loader,
    Header,
    Radio,
    Select,
    Message,
    Card,
    Divider, Icon
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {toast} from "react-toastify";


export default class RadioQuestionPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            value:'',
            showDeleteButton: this.props.showDeleteButton,
            radioGroupErr: false,
            admin: !!((localStorage.getItem('activeRole').startsWith('Administrator') || localStorage.getItem('activeRole').startsWith('QA admin:')))


        };
        this.setOptions = this.setOptions.bind(this);
        // this.validateInput = this.validateInput.bind(this);
    }

    componentDidMount() {
        this.setOptions(this.props.from, this.props.to);
    }
    setOptions(from, to) {
        let options = [];
        for (let i = from; i <= to; i += 1) {
            options.push(i);
        }
        this.setState({ options });
    }

// validateInput(){
//         console.log('printam opet')
//         if(!this.state.radioGroup){
//             toast('Unesite sve odg')
//             this.setState({radioGroupErr: true})
//         }else {
//             this.setState({radioGroupErr: false})
//         }
//
// }

    handleChange = (e, { value }) => {  this.setState({ value });
        if(!this.state.admin)this.props.submitRadioQuestion(this.props.questionId,value,this.props.staff,this.state.value === -1.0,this.props.typeName);
    };


    // skala
    render() {
        let question = {
            text: this.props.text,
            section: 'prof',
            typeName: this.props.typeName,
            questionId: this.props.questionId,
            np: this.props.np
            // np:1
        };
        return (
            <Fragment>


                <Header as="h4"><span style={{ color: 'red' }}>* &nbsp;</span> {question.text} {this.props.showDeleteButton && <Header as="h5" floated="right" ><span style={{ fontSize: '15px' }}>

                    <Icon name="trash alternate" link onClick={() => { this.props.deleteQuestion(question.questionId); }} > </Icon>
                </span></Header>}
                </Header>
                {this.props.showHeaderDivider && <Divider />}
                <Form >
                    <Grid columns={2} centered stackable >
                        <Grid.Column width={16} stretched>
                            <Form.Group widths={10} >
                                { this.state.options.map((index,i) => (
                                    <Form.Field key={i}
                                                error={this.state.radioGroupErr} >
                                        <Radio

                                            key={i}
                                            label={index}
                                            name="radioGroup"
                                            value={index}
                                            checked={this.state.value === index}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Field>


                                ))}
                                {question.np && <Form.Field
                                                            error={this.state.radioGroupErr}>
                                    <Radio

                                        label="Ne mogu procijeniti"
                                        name="radioGroup"
                                        value={-1.0}
                                        checked={this.state.value === -1.0}
                                        onChange={this.handleChange}
                                    />
                                </Form.Field>}

                            </Form.Group>
                        </Grid.Column>

                    </Grid>
                </Form>

                {this.props.showDivider && <Divider />}


            </Fragment>
        );
    }
}
RadioQuestionPreview.propTypes = {
    submitRadioQuestion: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/QuestionPreviews/RadioQuestionPreview.js